import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from '@awaze/design-system.components.stack';
import styled from 'styled-components';
import { breakpoints } from '@awaze/design-system.utils.react';
import { getGaAttribute } from '../utils/ga-attribute';
import { NavigationItem } from '../navigation-item/navigation-item';
import { NavigationItemWithPopover } from '../navigation-item/navigation-item-with-popover';
import { NavigationItemWithMegaMenu } from '../navigation-item/navigation-item-with-mega-menu';
export const StyledNav = styled.nav `
  display: none;

  /*
   ** The breakpoint is determined based on whether the mega menu or tablet view is enabled.
   ** The reason for this is that the opened mega menu has a fixed width of the full content width.
   ** If the screen was smaller, it would start to clip on the left and right.
   ** To circumvent this, we switch to a burger menu when the screen hits the minimum size it can populate without clipping.
   */
  @media screen and (min-width: ${({ showMegaMenu }) => showMegaMenu ? '1220px' : `${breakpoints[0]}px`}) {
    display: flex;
  }
`;
export const DesktopMenu = ({ brand, user, menuItems, showMegaMenu, }) => {
    return (_jsx(StyledNav, { showMegaMenu: showMegaMenu, children: _jsx(Stack, { isHorizontal: true, as: "ul", align: "center", children: menuItems.map((navItem, idx) => {
                const linkPosition = idx + 1; // 1-based index for analytics
                if (navItem.megaMenu && showMegaMenu) {
                    return (navItem.link.displayText && (_jsx(NavigationItemWithMegaMenu, { brand: brand, linkPosition: linkPosition, ...navItem }, `desktop-menu-${navItem.id}`)));
                }
                if (navItem.subMenu) {
                    return (_jsx(NavigationItemWithPopover, { brand: brand, user: user, linkPosition: linkPosition, ...navItem }, `desktop-menu-${navItem.id}`));
                }
                if (navItem.link.href && navItem.link.displayText) {
                    return (_jsx(NavigationItem, { brand: brand, ...navItem, dataGa: getGaAttribute('navigationlink', navItem.link.displayText, navItem.link.href, linkPosition) }, `desktop-menu-${navItem.id}`));
                }
                return null;
            }) }) }));
};
//# sourceMappingURL=desktop-menu.js.map